import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4" }
const _hoisted_2 = { class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "!tw-text-[orange]" }, "Terms & Conditions", -1)
const _hoisted_4 = { class: "tw-w-full tw-grid tw-grid-cols-2 tw-items-center tw-gap-3" }

import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import Button from "@/core/components/ui/general/Button.vue";
import Text from "@/core/components/ui/general/Text.vue";
import ContractSignYellowIcon from "@/core/components/icons/ContractSignYellowIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AcceptProjectEstimateModal',
  props: {
  isLoading: {
    default: false,
    type: Boolean,
  },
},
  emits: ["on-close", "on-save"],
  setup(__props, { emit: __emit }) {

const emits = __emit;
const props = __props;
const onCloseModal = () => {
  emits("on-close");
};

const onConfirm = () => {
  emits("on-save");
};

return (_ctx: any,_cache: any) => {
  const _component_ContractAcceptSignYellowIcon = _resolveComponent("ContractAcceptSignYellowIcon")!

  return (_openBlock(), _createBlock(GeneralDialog, {
    class: "accept_project_estimate_modal",
    onOnClose: onCloseModal,
    width: "460px",
    "max-width": "100%"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ContractAcceptSignYellowIcon),
        _createVNode(Text, {
          variant: "h4",
          textAlign: "center",
          lineHeight: "28px",
          class: "tw-max-w-[70%] md:tw-max-w-full"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Are you happy to accept the estimate?")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Text, {
          class: "tw-max-w-[80%] tw-mt-6",
          variant: "h6",
          textWeight: "500",
          textColor: "rgba(12, 15, 74, 0.5)",
          textAlign: "center"
        }, {
          default: _withCtx(() => [
            _createTextVNode("All estimates need to follow our "),
            _hoisted_3
          ]),
          _: 1
        })
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(Button, {
          variant: "tertiary",
          disabled: props.isLoading,
          label: "Cancel",
          letterSpacing: "1.25px",
          onClick: onCloseModal,
          class: "button button-purple-border"
        }, null, 8, ["disabled"]),
        _createVNode(Button, {
          label: "Accept",
          isLoading: props.isLoading,
          onClick: onConfirm,
          letterSpacing: "1.25px",
          class: "button button-orange"
        }, null, 8, ["isLoading"])
      ])
    ]),
    _: 1
  }))
}
}

})